// Fix for Korut menu item outline
document.addEventListener('DOMContentLoaded', function() {
  // Function to remove outline from Korut menu item
  function removeKorutOutline() {
    // Try to find the Korut menu item by its text content
    const menuItems = document.querySelectorAll('.header__menu-item');
    let korutMenuItem = null;
    
    // Find the menu item with text 'Korut'
    menuItems.forEach(item => {
      const span = item.querySelector('span');
      if (span && span.textContent.trim() === 'Korut') {
        korutMenuItem = item;
      }
    });
    
    if (korutMenuItem) {
      // Remove focus styles when the menu item is clicked
      korutMenuItem.addEventListener('mousedown', function(e) {
        // Prevent default to avoid any focus behavior
        e.preventDefault();
        
        // Remove focus outline
        this.style.outline = 'none';
        this.style.boxShadow = 'none';
        this.style.border = 'none';
        
        // Toggle the details element (for the dropdown)
        const details = this.closest('details');
        if (details) {
          details.open = !details.open;
        }
        
        // Re-enable focus outline for keyboard navigation
        setTimeout(() => {
          this.style.outline = '';
          this.style.boxShadow = '';
          this.style.border = '';
        }, 0);
      });
      
      // Also remove focus outline when the element receives focus
      korutMenuItem.addEventListener('focus', function() {
        this.style.outline = 'none';
        this.style.boxShadow = 'none';
        this.style.border = 'none';
      });
      
      // Remove focus outline when the element is clicked (for touch devices)
      korutMenuItem.addEventListener('click', function(e) {
        this.style.outline = 'none';
        this.style.boxShadow = 'none';
        this.style.border = 'none';
      });
    }
  }
  
  // Run the function when the page loads
  removeKorutOutline();
  
  // Also run it after a short delay to catch any dynamically loaded elements
  setTimeout(removeKorutOutline, 1000);
});
